import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getProfile } from 'src/store/app.state.store'
import { APIService } from 'api/APIService'
import { AppButton } from 'components/FormElements/AppButton/AppButton'
import { UserInfo } from 'components/Profile/UserInfo/UserInfo'
import styles from './AccountPreview.module.scss'

const MINUTE = 60 * 1000

const startOfMinute = (time: number) => Math.floor(time / MINUTE) * MINUTE

type AccountPreviewProps = {
  onClickProfile?: () => void,
  onClickAppointment?: () => void,
  onClickSignOut?: () => void,
}

/** The account popup: user info, cashback code that refreshes every minute, actions */
export const AccountPreview: React.FC<AccountPreviewProps> = (props) => {
  const { onClickProfile, onClickAppointment, onClickSignOut } = props
  const profile = useSelector(getProfile)

  const [code, setCode] = useState<string>()
  const [currentMinute, setCurrentMinute] = useState(() => startOfMinute(Date.now()))
  const [countdown, setCountdown] = useState(() => Date.now() - startOfMinute(Date.now()))

  const stopAnd = (handler?: () => void) => (e: React.MouseEvent) => {
    e.stopPropagation()
    handler?.()
  }
  const handleClickProfile = stopAnd(onClickProfile)
  const handleClickAppointment = stopAnd(onClickAppointment)
  const handleClickSignOut = stopAnd(onClickSignOut)

  useEffect(() => {
    const interval = setInterval(() => {
      if (currentMinute + MINUTE < Date.now()) {
        setCurrentMinute(currentMinute + MINUTE)
        APIService.profile.generateCashbackCode().then(setCode)
      }
      setCountdown(Date.now() - currentMinute)
    }, 1000)
    return () => clearInterval(interval)
  }, [currentMinute])

  useEffect(() => {
    APIService.profile.generateCashbackCode().then(setCode)
  }, [])

  return (
    <div className={styles.container}>
      <UserInfo user={profile} />
      {profile && (
        <div className={styles.visitsInfo}>
          Активные записи: {profile.appointmentsCount} | Подарки: {profile.giftsCount}
        </div>
      )}
      <div className={styles.cashbackCodeContainer}>
        <div className={styles.cashbackCodeTitle}>
          Код для списания кешбэка
        </div>
        <div className={styles.cashbackCode}>
          {code}
        </div>
        <div className={styles.cashbackCountdown}>
          обновится через {60 - Math.floor(countdown / 1000)}
        </div>
      </div>
      <div className={styles.actions}>
        <AppButton onClick={handleClickProfile} className={styles.profile}>
          Личный кабинет
        </AppButton>
        <AppButton onClick={handleClickAppointment} className={styles.appointmentButton}>
          Записаться
        </AppButton>
        <button onClick={handleClickSignOut} className={styles.signOut}>
          Выход
        </button>
      </div>
    </div>
  )
}
